import type { EventVaultType } from "./eventVault"
import type { IPaymentInfoResponse } from "@/types"
import { EventVaultSettings } from "@/models/eventVaultSettings"

export interface UpgradeableFreemiumEvent {
  eventVaultId: number
  title: string
}

export class PaymentInfo {
  public price: number
  public currency: string
  public currencyCode: string
  public productName: string
  public email?: string
  public eventVaultType?: EventVaultType
  public defaultSettings?: EventVaultSettings
  public upgradeableFreemiumEvent?: UpgradeableFreemiumEvent

  constructor(info: Partial<PaymentInfo>) {
    this.price = info.price ?? 0
    this.currency = info.currency ?? ""
    this.currencyCode = info.currencyCode ?? "?"
    this.productName = info.productName ?? "Unknown Product"
    this.email = info.email
    this.eventVaultType = info.eventVaultType
    this.defaultSettings = info.defaultSettings
    this.upgradeableFreemiumEvent = info.upgradeableFreemiumEvent
  }

  public static fromResponse(response?: IPaymentInfoResponse) {
    return new PaymentInfo({
      price: response?.Price,
      currency: response?.Currency,
      currencyCode: response?.CurrencyCode,
      productName: response?.Product?.Name,
      email: response?.Email,
      eventVaultType: response?.EventVaultTypeID,
      defaultSettings: EventVaultSettings.fromResponse(response?.Product?.Settings),
      upgradeableFreemiumEvent: response?.UpgradeableFreemiumEvent
        ? {
            eventVaultId: response.UpgradeableFreemiumEvent.EventVaultID,
            title: response.UpgradeableFreemiumEvent.Title,
          }
        : undefined,
    })
  }
}
